class AgeGatePopup extends HTMLElement {
  constructor() {
    super();
    this.cookieName = this.dataset.cookieName || 'rc_age_verified';
    this.minAge = parseInt(this.dataset.minAge, 10) || 21;

    this.dialog = this.querySelector('.age-gate__dialog');
    this.formWrapper = this.querySelector('[data-age-gate-form-wrapper]');
    this.deniedWrapper = this.querySelector('[data-age-gate-denied]');
    this.form = this.querySelector('[data-age-gate-form]');
    this.errorElement = this.querySelector('[data-age-gate-error]');

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  connectedCallback() {
    if (!this.isVerified()) {
      this.open();
    }
  }

  isVerified() {
    return document.cookie.split('; ').includes(`${this.cookieName}=1`);
  }

  rememberVerification() {
    const oneYearInSeconds = 60 * 60 * 24 * 365;
    document.cookie = `${this.cookieName}=1; max-age=${oneYearInSeconds}; path=/; SameSite=Lax`;
  }

  open() {
    this.hidden = false;
    document.body.classList.add('overflow-hidden');
    trapFocus(this.dialog);
  }

  close() {
    this.hidden = true;
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus();
  }

  onSubmit(event) {
    event.preventDefault();
    this.hideError();

    const formData = new FormData(this.form);
    const month = parseInt(formData.get('month'), 10);
    const day = parseInt(formData.get('day'), 10);
    const year = parseInt(formData.get('year'), 10);

    if (!month || !day || !year) {
      this.showError(window.ageGateStrings?.missingFields);
      return;
    }

    const birthDate = new Date(year, month - 1, day);
    const isValidDate =
      birthDate.getFullYear() === year && birthDate.getMonth() === month - 1 && birthDate.getDate() === day;

    if (!isValidDate) {
      this.showError(window.ageGateStrings?.invalidDate);
      return;
    }

    if (this.getAge(birthDate) < this.minAge) {
      this.showDenied();
      return;
    }

    this.rememberVerification();
    this.close();
  }

  getAge(birthDate) {
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasHadBirthdayThisYear) age--;

    return age;
  }

  showError(message) {
    if (!message) return;
    this.errorElement.textContent = message;
    this.errorElement.hidden = false;
  }

  hideError() {
    this.errorElement.hidden = true;
  }

  showDenied() {
    this.formWrapper.hidden = true;
    this.deniedWrapper.hidden = false;
  }
}

customElements.define('age-gate-popup', AgeGatePopup);
